var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import styled, { css } from 'styled-components';
import { parametricStyle, parametricWidth } from './utils';
export var StyledContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  box-sizing: border-box;\n  display: flex;\n\n  ", "\n"], ["\n  box-sizing: border-box;\n  display: flex;\n\n  ", "\n"])), gridPropsToCSS);
export var StyledBox = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  box-sizing: border-box;\n\n  ", "\n"], ["\n  box-sizing: border-box;\n\n  ", "\n"])), function (_a) {
  var width = _a.width;
  return width && parametricWidth(width, 'auto');
});
var DEFAULT_PROPS = {
  flow: 'row',
  justifyContent: 'start',
  alignItems: 'start',
  gap: 'md',
  width: 12,
  fluid: false
};
function gridPropsToCSS(props) {
  var appliedProps = __assign(__assign({}, DEFAULT_PROPS), props);
  return css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    flex-wrap: ", ";\n\n    ", ";\n\n    ", ";\n\n    ", "\n\n    ", "\n\n    ", "\n  "], ["\n    flex-wrap: ", ";\n\n    ", ";\n\n    ", ";\n\n    ", "\n\n    ", "\n\n    ", "\n  "])), appliedProps.fluid ? 'wrap' : 'nowrap', appliedProps.justifyContent && parametricStyle('justify-content', appliedProps.justifyContent), appliedProps.alignItems && parametricStyle('align-items', appliedProps.alignItems), appliedProps.flow && parametricStyle('flex-direction', appliedProps.flow), appliedProps.gap && function (_a) {
    var theme = _a.theme;
    return parametricStyle('gap', appliedProps.gap, function (gap) {
      return gap === null ? 'none' : theme.tokens.spacing[gap];
    });
  }, appliedProps.width && parametricWidth(appliedProps.width, '100%'));
}
var templateObject_1, templateObject_2, templateObject_3;